module.exports = __webpack_public_path__ + "static/img/areaA-19.09f18b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-19.png
// module id = 930
// module chunks = 1